import { PATTERN } from "@/constants/pattern";
import { Link } from "@mui/material";
import { FC, Fragment } from "react";

type TTextWithLinksProps = {
  text: string;
};

export const TextWithLinks: FC<TTextWithLinksProps> = ({ text }) => {
  const parts = text.split(PATTERN.URL_INLINE);
  return (
    <>
      {parts.map((part, index) =>
        PATTERN.URL_INLINE.test(part) ? (
          <Link key={index} href={part} target="_blank" rel="noopener noreferrer" underline="none" color="primary">
            {part}
          </Link>
        ) : (
          <Fragment key={index}>{part}</Fragment>
        ),
      )}
    </>
  );
};
